import { render, staticRenderFns } from "./h-txt-banner.vue?vue&type=template&id=33953471&scoped=true"
import script from "./h-txt-banner.vue?vue&type=script&lang=js"
export * from "./h-txt-banner.vue?vue&type=script&lang=js"
import style0 from "./h-txt-banner.vue?vue&type=style&index=0&id=33953471&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33953471",
  null
  
)

export default component.exports